import { ElMessage } from 'element-plus'
import { useReportCreation } from '@/widgets/WReportCreation/composables/useReportCreation'
import {
  NullReportCreationType,
  PatientAndReportCreationType,
  ReportCreationType,
} from '@/shared/types'
import { reportCreationApi } from '@/shared/api'
import { showErrorMessage } from '@/shared/utils'
import { usePatientListing } from '@/shared/composables'
import { ReportCreationResponseType } from '@/widgets/WReportCreation/types/reportCreation.types'

const { updatePatientListing } = usePatientListing()
const {
  selectedPatient,
  isPigmentedPlaque,
  receiptDate,
  teethStone,
  getImagesFiles,
  getImagesRotations,
  patientCreationFormData,
  teethCaries,
  teethFilling,
  teethExtracted,
} = useReportCreation()

export const checkTeethStone = (): Boolean => {
  return teethStone.value.length !== 0
}
export const checkImagesFiles = (): Boolean => {
  return getImagesFiles().length !== 0
}
export const createReport = async (): Promise<ReportCreationResponseType> => {
  if (!selectedPatient.value) {
    ElMessage({
      message: 'Выберите пациента',
      type: 'error',
    })

    return undefined
  }

  const reportData: ReportCreationType = {
    date: new Date(receiptDate.value),
    stone: teethStone.value,
    images: getImagesFiles(),
    image_rotations: getImagesRotations(),
    patientId: selectedPatient.value.id,
    pigmented: isPigmentedPlaque.value ? 1 : 0,
    caries: teethCaries.value,
    filling: teethFilling.value,
    extracted: teethExtracted.value,
  }

  const [error, response] = await reportCreationApi.createReport(reportData)

  const isError = handleError(error)

  if (isError) return undefined

  return {
    patientId: selectedPatient.value.id,
    reportId: response.data.report_id,
  }
}

export const createNullReport =
  async (): Promise<ReportCreationResponseType> => {
    const reportData: NullReportCreationType = {
      date: new Date(receiptDate.value),
      stone: teethStone.value,
      images: getImagesFiles(),
      image_rotations: getImagesRotations(),
      pigmented: isPigmentedPlaque.value ? 1 : 0,
      caries: teethCaries.value,
      filling: teethFilling.value,
      extracted: teethExtracted.value,
    }

    const [error, response] = await reportCreationApi.createReportNull(
      reportData
    )

    const isError = handleError(error)

    if (isError) return undefined

    return {
      patientId: 'null-patient',
      reportId: response.data.report_id,
    }
  }

export const createPatientAndReport =
  async (): Promise<ReportCreationResponseType> => {
    const reportData: PatientAndReportCreationType = {
      dateAt: new Date(receiptDate.value),
      stone: teethStone.value,
      images: getImagesFiles(),
      image_rotations: getImagesRotations(),
      surname: patientCreationFormData.surname,
      name: patientCreationFormData.name,
      patronymic: patientCreationFormData.patronymic,
      email: patientCreationFormData.email,
      phone: patientCreationFormData.phone,
      cartNumber: patientCreationFormData.cartNumber,
      date: new Date(patientCreationFormData.date),
      pigmented: isPigmentedPlaque.value ? 1 : 0,
      caries: teethCaries.value,
      filling: teethFilling.value,
      extracted: teethExtracted.value,
    }

    const [error, response] = await reportCreationApi.createPatientAndReport(
      reportData
    )

    const isError = handleError(error)

    if (isError) return undefined

    return {
      patientId: response.data.patient_id,
      reportId: response.data.report_id,
    }
  }

// TODO: При внесении дальнейшей правки по обработке ошибок от заказчика добавить типизацию ошибки
const handleError = (error: any): boolean => {
  if (error) {
    showErrorMessage(error)

    return true
  }

  ElMessage({
    message: 'Отчет создан',
    type: 'success',
  })

  updatePatientListing(true)

  return false
}
